import { z } from "zod";

const uploadCustomThumbnailSchema = z.object({
  thumbnailURL: z
    .string({ required_error: "Thumbnail URL is required" })
    .min(1, { message: "Select a thumbnail" }),
});
type UploadCustomThumbnailFormData = z.infer<
  typeof uploadCustomThumbnailSchema
>;

export { uploadCustomThumbnailSchema };
export type { UploadCustomThumbnailFormData };
